import { Grid } from '@mui/material'
import React from 'react'
import { TopBarUserVisibilityType } from '../../types'
import { TopBarLanguageSelect } from '../top-bar-language-select'
import { TopBarUserNameWrapper } from '../top-bar-user-name-wrapper'
import { DesktopLogoutLink } from './desktop-logout-link'

type DesktopLangAndUserProps = TopBarUserVisibilityType

export const DesktopLangAndUser = ({
  showUserName
}: DesktopLangAndUserProps) => {
  return (
    <Grid alignItems="center" container justifyContent="space-between" spacing={8}>
      <Grid item>
        <TopBarLanguageSelect isMobile={false} />
      </Grid>
      <Grid item>
        <Grid alignItems="center" container direction="column">
          <Grid item id="topbar-userinfo-name">
            <TopBarUserNameWrapper
              isMobile={false}
              showUserName={showUserName}
            />
          </Grid>
          <Grid item>
            <DesktopLogoutLink />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}
